export const Logo = ({ className = "h-10 w-auto", testId }) => (
    <img
        src="/logo.png"
        alt="Rey Detailing logo"
        className={className}
        data-testid={testId}
    />
);
